export default (options) => {
  if (!options && options.length) {
    return { key: 0, text: 'All', value: 'all' };
  }
  const parsed = options.map(el => ({ key: el.id, text: el.name, value: el.id }));
  return [...parsed];
};

export function parseMVIdOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({ key: el.id, text: `Id: ${el.id}-${el.name}`, value: el.id }));
  return [...parsed];
}

export function parseTaxTypesOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: `igst: ${el.igst} | cgst: ${el.cgst} | sgst: ${el.sgst}`,
    value: el.id
  }));
  return [...parsed];
}

export function parseUserListOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: `${el.mobile} - ${el.full_name || 'N/A'}`,
    value: el.id
  }));
  return [...parsed];
}

export function parseVMCitiesOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.city,
    text: el.city,
    value: el.city
  }));
  return [...parsed];
}

export function parseVMCohortOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: `${el.name} | ${el.area_name} | VMs(${el.total_vms})`,
    value: el.id
  }));
  return [...parsed];
}
export function parseVMCohortTypesOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: `${el.name}`,
    value: el.id
  }));
  return [...parsed];
}
export function parseStateAndCityOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: el.name,
    value: `${el.id}-${el.name}`
  }));
  return [...parsed];
}
export function parseVMTypeOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: el.type,
    value: el.id
  }));
  return [...parsed];
}


export function parseSlotsOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.slot_id,
    text: el.slot_id,
    value: `${el.slot_id}`,
  }));
  return [...parsed];
}
export function parseVmHdTypeOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: el.name,
    value: `${el.id}-${el.name}`
  }));
  return [...parsed];
}
export function parseVmLoctonTypeOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: el.name,
    value: `${el.id}`
  }));
  return [...parsed];
}

export function parseOperationalOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: el.name,
    value: `${el.id}`
  }));
  return [...parsed];
}
export function parseCohortOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    id: el.id,
    text: el.name,
    value: `${el.id}`
  }));
  return [...parsed];
}
export function parseWarehouseOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    id: el.id,
    text: el.name,
    value: `${el.id}`
  }));
  return [...parsed];
}

export function parsePaymentsOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'None', value: 0 };
  }
  const parsed = options.map(el => ({
    id: el.id,
    text: el.name,
    value: `${el.id}`
  }));
  return [...parsed];
}

export function parseVMDetailsOptions(options) {
  if (!options && options.length) {
    return { key: 0, text: 'All', value: 'all' };
  }
  const parsed = options.map(el => ({
    key: el.id,
    text: `Id: ${el.id} | ${el.name}`,
    value: el.id
  }));
  return [...parsed];
}



// WEBPACK FOOTER //
// ./src/utils/parseResponseToOptions.js